module.exports = __webpack_public_path__ + "static/latin-quarter-poster-8028cd90a43eaeb8d78b319897a6ca25.jpg";